

import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/typography.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_269_0_Heading";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_269_0_Heading__root","heading-xl":"wds_1_269_0_StylableTypography__heading-xl","heading-l":"wds_1_269_0_StylableTypography__heading-l","heading-m":"wds_1_269_0_StylableTypography__heading-m","heading-s":"wds_1_269_0_StylableTypography__heading-s","heading-t":"wds_1_269_0_StylableTypography__heading-t","heading-xt":"wds_1_269_0_StylableTypography__heading-xt"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-color-text-standard-primary":"--wds-color-text-standard-primary","wds-color-text-standard-primary-light":"--wds-color-text-standard-primary-light","wds-color-text-standard-secondary":"--wds-color-text-standard-secondary"}; 




